<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   stroke-width="2"
   stroke-linecap="round"
   stroke-linejoin="round"
   class="feather feather-upload-cloud"
   version="1.1"
   id="svg2"
   sodipodi:docname="upload.svg"
   inkscape:version="1.3.2 (091e20ef0f, 2023-11-25, custom)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs2" />
  <sodipodi:namedview
     id="namedview2"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="30.708333"
     inkscape:cx="12.016282"
     inkscape:cy="12.537313"
     inkscape:window-width="1916"
     inkscape:window-height="1036"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg2" />
  <polyline
     points="16 16 12 12 8 16"
     id="polyline1"
     transform="matrix(0.9,0,0,0.9,1.2001804,1.2002762)" />
  <line
     x1="12.00018"
     y1="12.000277"
     x2="12.00018"
     y2="20.100277"
     id="line1"
     style="stroke-width:1.8" />
  <path
     d="m 19.55118,17.751276 a 4.5,4.5 0 0 0 -2.151,-8.4509998 h -1.134 A 7.2,7.2 0 1 0 3.9001804,15.870276"
     id="path1"
     style="stroke-width:1.8" />
  <polyline
     points="16 16 12 12 8 16"
     id="polyline2"
     transform="matrix(0.9,0,0,0.9,1.2001804,1.2002762)" />
</svg>
